import { FC, useState } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getCoreScreenSize } from 'CorePackage/MainModule/selectors/coreSelectors';

import styles from './styles.module.scss';

interface IKnmSubtitleComponentProps {
  title?: string;
}

interface IKnmSubtitleComponentStoreProps {
  screenSize: string;
}

const KnmSubtitleComponent: FC<IKnmSubtitleComponentProps & IKnmSubtitleComponentStoreProps> = ({
  title,
  screenSize,
  children,
}) => {
  const isMobile = screenSize === 'mobile';
  const [isRolledUp, setIsRolledUp] = useState(isMobile);

  const onClickHandler = () => {
    setIsRolledUp(prev => !prev);
  };

  return (
    <>
      <div
        className={cn(styles.SectionTitle, { [styles.MobileSectionTitle]: isMobile })}
        onClick={isMobile ? onClickHandler : undefined}
      >
        {title}
        {isMobile && (
          <span className={styles.CollapseIconWrapper}>
            <span className={styles.CollapseIcon} />
          </span>
        )}
      </div>
      <div className={cn({ [styles.RolledUpSectionTitle]: isRolledUp })}>{children}</div>
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  screenSize: getCoreScreenSize(state),
});

export const KnmSubtitle = connect(mapStateToProps)(KnmSubtitleComponent);
